export var ObSessionStateType;

(function (ObSessionStateType) {
  ObSessionStateType["SESSION_EXISTS"] = "SESSION_EXISTS";
  ObSessionStateType["NO_SESSION"] = "NO_SESSION";
  ObSessionStateType["SESSION_REQUESTED"] = "SESSION_REQUESTED";
  ObSessionStateType["SESSION_UNKNOWN"] = "SESSION_UNKNOWN";
})(ObSessionStateType || (ObSessionStateType = {}));
//# sourceMappingURL=enums.js.map